<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="4" md="2" class="text-center outlined">{{ $t('FreeTimeSetting.week') }}</v-col>
      <v-col cols="8" md="10" class="text-center outlined">{{ $t('FreeTimeSetting.freeTime') }}</v-col>
    </v-row>
    <v-row v-for="freeTimeData in freeTimeView" dense :key="freeTimeData.date.date">
      <v-col cols="4" md="2" class="outlined d-flex text-center align-center justify-center">
        <div>
          {{ freeTimeData.date.date }}<br>{{ weekdays[freeTimeData.date.weekday] }}
          <div v-if="slotClosedDates.includes(freeTimeData.date.date)" class="slot-closed-tag">已關閉空檔</div>
        </div>
      </v-col>
      <v-col cols="8" md="10" class="outlined d-flex align-center flex-wrap">
        <v-chip
          v-for="(time, index) in freeTimeData.openingTime"
          :key="index"
          class="mr-2 my-1"
          :small="$vuetify.breakpoint.width < 1040"
          v-text="time"
          :color="slotClosedDates.includes(freeTimeData.date.date) ? SLOT_CLOSED_CHIP.color : 'primary'"
          :text-color="slotClosedDates.includes(freeTimeData.date.date) ? SLOT_CLOSED_CHIP.textColor : 'black'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { SLOT_CLOSED_CHIP } from "@/utils/slotClosure";

export default {
  name: "ManualView",

  props: {
    selectSetting: {
      type: String,
      required: false
    },
    dateList: {
      type: Array,
      required: true
    },
    weekdays: {
      type: Array,
      required: true
    },
    slotClosedDates: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      freeTimeView: [],
      SLOT_CLOSED_CHIP
    }
  },

  computed: {
    ...mapGetters([
      'manualWeekly',
      'manualSingle',
      'manualClosed'
    ]),
  },

  watch: {
    selectSetting: {
      handler(v) {
        if (v === 'view') this.processView()
      },
      immediate: true
    }
  },

  methods: {
    processView() {
      this.freeTimeView = this.dateList.map(date => {
        let openingTime = this.manualSingle[date.date] ? this.manualSingle[date.date].slice(0) : []
        if (!this.manualClosed.includes(date.date)) {
          openingTime = openingTime.concat(this.manualWeekly[date.weekday])
        }
        return {
          date,
          openingTime: new Set(openingTime.sort())
        }
      })
    }
  }
}
</script>

<style scoped>
.outlined {
  border: 1px solid #707070;
}

.slot-closed-tag {
  width: fit-content;
  margin: 4px auto 0;
  padding: 0 8px;
  border-radius: 3px;
  background: #eee;
  font-size: 12px;
  line-height: 1.8;
  color: #757575;
}
</style>
